'use strict';

require('react');
var SymbolsCounter_style = require('./SymbolsCounter.style-64b0606b.js');
var react = require('@emotion/react');
var Paragraph = require('./Paragraph-284fa117.js');

var Affix = function Affix(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    className = _ref.className;
  if (typeof children === 'string' || typeof children === 'number') {
    return react.jsx(SymbolsCounter_style.AffixWrapper, {
      className: className,
      "data-affix-disabled": disabled
    }, react.jsx(Paragraph.P2, {
      className: "n-affix-text"
    }, children));
  }
  return react.jsx(SymbolsCounter_style.AffixWrapper, {
    className: className,
    "data-affix-disabled": disabled
  }, children);
};

exports.Affix = Affix;
//# sourceMappingURL=Affix-535aba61.js.map
